import {
  Text,
  VStack,
  Center,
  AccordionItem,
  AccordionPanel,
  AccordionButton,
} from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { memo, useCallback } from 'react';

import FaqItemToggle from 'shared/FaqItemToggle';

import { DEFAULT_TRANSITION, EMPTY_OBJECT } from 'constants/global';

const FaqItemComponent = ({
  index,
  title,
  description,
  setActiveIndex,
  maxVisibleItems = null,
}) => {
  const handleSetActiveIndex = useCallback(
    newIndex => setActiveIndex(newIndex ?? (maxVisibleItems ?? 0) + index),
    [maxVisibleItems, index, setActiveIndex],
  );

  return (
    <AccordionItem
      w="full"
      border="none"
      bg="ourWhite"
      color="ourBlack"
      borderRadius={{ mobile: '14px', tablet: '18px', laptop: '24px' }}
    >
      {({ isExpanded }) => (
        <>
          <AccordionButton
            role="group"
            w="full"
            flex="1"
            justifyContent="space-between"
            alignItems={{ mobile: 'start', tablet: 'center' }}
            gap={{ mobile: '40px', laptop: '32px' }}
            p={{ mobile: '16px 24px', tablet: '32px 48px', laptop: '33px 40px 33px 48px' }}
            pb={isExpanded && { laptop: '32px' }}
            transition={DEFAULT_TRANSITION}
            _hover={EMPTY_OBJECT}
            _focusVisible={EMPTY_OBJECT}
            onClick={() => (isExpanded ? handleSetActiveIndex(-1) : handleSetActiveIndex())}
          >
            <Text textStyle="b2" textAlign="start" dangerouslySetInnerHTML={{ __html: title }} />

            <Center
              as={motion.div}
              animate={isExpanded ? 'open' : 'closed'}
              borderRadius="full"
              transition={DEFAULT_TRANSITION}
              p={{ mobile: '3px', tablet: '7.5px', laptop: '15px' }}
              _groupFocusVisible={{ laptop: { bgColor: '#85858526' } }}
              _groupHover={{ laptop: { bgColor: '#85858526' } }}
            >
              <FaqItemToggle />
            </Center>
          </AccordionButton>

          <AccordionPanel
            motionProps={{ unmountOnExit: true }}
            p={{ mobile: '16px 24px', tablet: '32px 48px', laptop: '0 120px 40px 48px' }}
            pt="0 !important"
          >
            {Array.isArray(description) ? (
              <VStack w="full" align="start" gap="18px">
                {description.map(({ title, text }) => (
                  <VStack key={title} w="full" align="start" gap="8px">
                    <Text
                      textStyle="b2"
                      fontSize={{ mobile: '16px', laptop: '20px' }}
                      dangerouslySetInnerHTML={{ __html: title }}
                    />

                    <Text
                      textStyle="b3"
                      fontWeight="400"
                      dangerouslySetInnerHTML={{ __html: text }}
                    />
                  </VStack>
                ))}
              </VStack>
            ) : (
              <Text
                textStyle="b3"
                fontWeight="400"
                dangerouslySetInnerHTML={{ __html: description }}
              />
            )}
          </AccordionPanel>
        </>
      )}
    </AccordionItem>
  );
};

export const FaqItem = memo(FaqItemComponent);
